var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calling"},[_c('div',[_vm._v("正在呼叫："+_vm._s(_vm.phoneNum))]),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.cancelCall}},[_vm._v("取消")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }